// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobile-carousel {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.mobile-carousel__gamelist {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  width: 100%;
  gap: 0.75rem;
  scrollbar-width: none;
  -ms-overflow-style: none;
  flex-flow: row;
}
.mobile-carousel__gamelist::-webkit-scrollbar {
  display: none;
}
.mobile-carousel__gamelist .mobile-carousel__wrapper {
  flex: 0 0 93%;
  min-width: 80%;
  scroll-snap-align: start;
}
.mobile-carousel__gamelist .mobile-carousel__wrapper:not(:only-child) {
  flex: 0 0 75%;
}
.mobile-carousel__gamelist .mobile-carousel__wrapper:first-child {
  margin-left: 0.75rem;
}
@media (orientation: landscape) {
  .mobile-carousel__gamelist .mobile-carousel__wrapper, .mobile-carousel__gamelist .mobile-carousel__wrapper:first-child {
    margin-left: 0;
  }
}
.mobile-carousel__gamelist .mobile-carousel__wrapper:last-child {
  margin-right: 0.75rem;
}
@media (min-width: 576px) {
  .mobile-carousel__gamelist .mobile-carousel__wrapper {
    flex: 0 0 calc(50% - 0.5rem);
    min-width: calc(50% - 0.5rem);
  }
  .mobile-carousel__gamelist .mobile-carousel__wrapper:first-child:nth-last-child(1) {
    flex: 0 0 100%;
    min-width: 100%;
  }
}
@media (min-width: 992px) {
  .mobile-carousel__gamelist {
    overflow-x: auto;
    gap: 1.25rem;
  }
  .mobile-carousel__gamelist .mobile-carousel__wrapper {
    flex: 0 0 calc(50% - 0.6rem);
    min-width: calc(50% - 0.6rem);
  }
  .mobile-carousel__gamelist .mobile-carousel__wrapper:first-child:nth-last-child(1) {
    flex: 0 0 100%;
    min-width: 100%;
  }
}
.mobile-carousel__listcontainer {
  position: relative;
  width: 100%;
}
@media (min-width: 992px) {
  .mobile-carousel__listcontainer .mobile-carousel__scrollbutton {
    display: none;
  }
}
.mobile-carousel .tile--anchor {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
  border-radius: 12px;
  overflow: hidden;
  background-color: #f5f5fa;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background-repeat: no-repeat;
  background-size: cover;
}
@media (min-width: 992px) {
  .mobile-carousel__wrapper:first-child:nth-last-child(1) .mobile-carousel .tile--anchor {
    padding-bottom: 35%;
    border-radius: 16px;
  }
}
.mobile-carousel .tile--anchor[lazyload] {
  background: linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%);
  background-size: 200% 100%;
  animation: 1.5s shine linear infinite;
}
.mobile-carousel__scrollbutton {
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  border: none;
  z-index: 2;
  transition: all 0.2s ease;
}
.mobile-carousel__scrollbutton ion-icon {
  font-size: 1.5rem;
  color: var(--ion-color-primary);
}
.mobile-carousel__scrollbutton--right {
  right: 0.5rem;
}
.mobile-carousel__scrollbutton--left {
  left: 0.5rem;
}

@keyframes shine {
  to {
    background-position-x: -200%;
  }
}
.banner-style img {
  width: 100%;
  object-fit: cover;
  display: block;
  width: 100%;
  height: auto;
  border-radius: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/mobile-carousel/mobile-carousel.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AACF;AAEE;EACE,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,wBAAA;EAGA,cAAA;AAFJ;AAII;EACE,aAAA;AAFN;AAMI;EACE,aAAA;EACA,cAAA;EACA,wBAAA;AAJN;AAMM;EACE,aAAA;AAJR;AAQM;EACE,oBAAA;AANR;AASM;EAEE;IAEE,cAAA;EATR;AACF;AAYM;EACE,qBAAA;AAVR;AAeI;EACE;IACE,4BAAA;IACA,6BAAA;EAbN;EAgBI;IACE,cAAA;IACA,eAAA;EAdN;AACF;AAoBI;EA5DF;IA8DI,gBAAA;IACA,YAAA;EAlBJ;EAoBI;IACE,4BAAA;IACA,6BAAA;EAlBN;EAuBI;IACE,cAAA;IACA,eAAA;EArBN;AACF;AA0BE;EACE,kBAAA;EACA,WAAA;AAxBJ;AA0BI;EACE;IACE,aAAA;EAxBN;AACF;AA8BI;EACE,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,qDAAA;EACA,wCAAA;EACA,4BAAA;EACA,sBAAA;AA5BN;AA+BQ;EADF;IAEI,mBAAA;IACA,mBAAA;EA5BR;AACF;AAgCM;EACE,yEAAA;EACA,0BAAA;EACA,qCAAA;AA9BR;AAoCE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;EACA,kBAAA;EACA,0CAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,UAAA;EACA,yBAAA;AAlCJ;AAqCI;EACE,iBAAA;EACA,+BAAA;AAnCN;AAsCI;EACE,aAAA;AApCN;AAuCI;EACE,YAAA;AArCN;;AA0CA;EACE;IACE,4BAAA;EAvCF;AACF;AA2CA;EACE,WAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAzCF","sourcesContent":[".mobile-carousel {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  // margin-bottom: 1.5rem;\n\n  &__gamelist {\n    display: flex;\n    overflow-x: auto;\n    overflow-y: hidden;\n    width: 100%;\n    gap: 0.75rem;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n    // padding-bottom: 0.5rem; \n    // margin: 0rem .75rem;\n    flex-flow: row;\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n\n\n    .mobile-carousel__wrapper {\n      flex: 0 0 93%;\n      min-width: 80%;\n      scroll-snap-align: start;\n\n      &:not(:only-child) {\n        flex: 0 0 75%;\n      }\n\n\n      &:first-child {\n        margin-left: 0.75rem;\n      }\n\n      @media (orientation: landscape) {\n\n        &,\n        &:first-child {\n          margin-left: 0;\n        }\n      }\n\n      &:last-child {\n        margin-right: 0.75rem;\n      }\n    }\n\n\n    @media (min-width: 576px) {\n      .mobile-carousel__wrapper {\n        flex: 0 0 calc(50% - 0.5rem);\n        min-width: calc(50% - 0.5rem);\n      }\n\n      .mobile-carousel__wrapper:first-child:nth-last-child(1) {\n        flex: 0 0 100%;\n        min-width: 100%;\n\n      }\n    }\n\n\n\n    @media (min-width: 992px) {\n      // flex-wrap: wrap;\n      overflow-x: auto;\n      gap: 1.25rem;\n\n      .mobile-carousel__wrapper {\n        flex: 0 0 calc(50% - 0.6rem);\n        min-width: calc(50% - 0.6rem);\n\n      }\n\n\n      .mobile-carousel__wrapper:first-child:nth-last-child(1) {\n        flex: 0 0 100%;\n        min-width: 100%;\n\n      }\n    }\n  }\n\n  &__listcontainer {\n    position: relative;\n    width: 100%;\n\n    @media (min-width: 992px) {\n      .mobile-carousel__scrollbutton {\n        display: none;\n      }\n    }\n  }\n\n\n  .tile {\n    &--anchor {\n      position: relative;\n      width: 100%;\n      padding-bottom: 56.25%; // 16:9 aspect ratio\n      border-radius: 12px;\n      overflow: hidden;\n      background-color: #f5f5fa;\n      transition: transform 0.3s ease, box-shadow 0.3s ease;\n      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n      background-repeat: no-repeat;\n      background-size: cover;\n\n      .mobile-carousel__wrapper:first-child:nth-last-child(1) & {\n        @media (min-width: 992px) {\n          padding-bottom: 35%;\n          border-radius: 16px;\n        }\n      }\n\n\n      &[lazyload] {\n        background: linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%);\n        background-size: 200% 100%;\n        animation: 1.5s shine linear infinite;\n      }\n    }\n  }\n\n\n  &__scrollbutton {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(255, 255, 255, 0.9);\n    border-radius: 50%;\n    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);\n    cursor: pointer;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 40px;\n    height: 40px;\n    border: none;\n    z-index: 2;\n    transition: all 0.2s ease;\n\n\n    ion-icon {\n      font-size: 1.5rem;\n      color: var(--ion-color-primary);\n    }\n\n    &--right {\n      right: 0.5rem;\n    }\n\n    &--left {\n      left: 0.5rem;\n    }\n  }\n}\n\n@keyframes shine {\n  to {\n    background-position-x: -200%;\n  }\n}\n\n\n.banner-style img {\n  width: 100%;\n  object-fit: cover;\n  display: block;\n  width: 100%;\n  height: auto;\n  border-radius: 5px;\n\n\n\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
